"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInsightListItemDropHandler = void 0;
// (C) 2022 GoodData Corporation
var sdk_model_1 = require("@gooddata/sdk-model");
var react_1 = require("react");
var model_1 = require("../../../model");
var widgets_1 = require("../../../widgets");
var sizing_1 = require("../../../_staging/layout/sizing");
function useInsightListItemDropHandler(sectionIndex, itemIndex) {
    var dispatch = model_1.useDashboardDispatch();
    var settings = model_1.useDashboardSelector(model_1.selectSettings);
    var preselectDateDataset = model_1.useDashboardCommandProcessing({
        commandCreator: model_1.enableInsightWidgetDateFilter,
        errorEvent: "GDC.DASH/EVT.COMMAND.FAILED",
        successEvent: "GDC.DASH/EVT.INSIGHT_WIDGET.FILTER_SETTINGS_CHANGED",
        onSuccess: function (event) {
            dispatch(model_1.uiActions.setWidgetLoadingAdditionalDataStopped(event.payload.ref));
        },
        onError: function (event) {
            dispatch(model_1.uiActions.setWidgetLoadingAdditionalDataStopped(event.payload.command.payload.ref));
        },
    }).run;
    var replaceSectionItemLoader = model_1.useDashboardCommandProcessing({
        commandCreator: model_1.replaceSectionItem,
        errorEvent: "GDC.DASH/EVT.COMMAND.FAILED",
        successEvent: "GDC.DASH/EVT.FLUID_LAYOUT.ITEM_REPLACED",
        onSuccess: function (event) {
            var ref = event.payload.items[0].widget.ref;
            dispatch(model_1.uiActions.selectWidget(ref));
            dispatch(model_1.uiActions.setConfigurationPanelOpened(true));
            dispatch(model_1.uiActions.setWidgetDateDatasetAutoSelect(true));
            dispatch(model_1.uiActions.setWidgetLoadingAdditionalDataStarted(ref));
            preselectDateDataset(ref, "default");
        },
    }).run;
    return react_1.useCallback(function (insight) {
        var correlationId = "insert-insight-list-item-" + sectionIndex + "_" + itemIndex;
        var sizeInfo = sizing_1.getSizeInfo(settings, "insight", insight);
        model_1.dispatchAndWaitFor(dispatch, model_1.addSectionItem(sectionIndex, itemIndex, {
            type: "IDashboardLayoutItem",
            size: {
                xl: {
                    gridHeight: sizeInfo.height.default,
                    gridWidth: sizeInfo.width.default,
                },
            },
            widget: widgets_1.newLoadingPlaceholderWidget(),
        }, false, correlationId)).then(function () {
            replaceSectionItemLoader(sectionIndex, itemIndex, {
                type: "IDashboardLayoutItem",
                widget: {
                    type: "insight",
                    insight: sdk_model_1.insightRef(insight),
                    ignoreDashboardFilters: [],
                    drills: [],
                    title: sdk_model_1.insightTitle(insight),
                    description: "",
                },
                size: {
                    xl: {
                        gridHeight: sizeInfo.height.default,
                        gridWidth: sizeInfo.width.default,
                    },
                },
            }, undefined, false, correlationId);
        });
    }, [replaceSectionItemLoader, dispatch, itemIndex, sectionIndex, settings]);
}
exports.useInsightListItemDropHandler = useInsightListItemDropHandler;
//# sourceMappingURL=useInsightListItemDropHandler.js.map